import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import type { assignProjectAndRoleToUserSchema } from "backend/src/schemas/organisationSchema";
import { z } from "zod";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";

type OrgAddMemberResponseType = ResponseType<{
  isChargeApplied: boolean;
  additionalMessage: string;
}>;

function useAssignProjectAndRoleToUserMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<OrgAddMemberResponseType>["response"],
    AxiosResponseAndError<OrgAddMemberResponseType>["error"],
    {
      userOrganisationId: string;
      data: z.infer<typeof assignProjectAndRoleToUserSchema>;
    }
  >({
    mutationFn: (data) =>
      ApiRequest.post<OrgAddMemberResponseType>(
        `${requestURLs.organisation}/assignProjectAndRoleToUser/${data.userOrganisationId}`,
        data.data
      ),
  });

  return mutation;
}

export default useAssignProjectAndRoleToUserMutation;
